import TimeSVG from "@design-system/ui-icons/vanilla/Time"
import { createIcon } from "../createIcon"

export const TimeIcon = createIcon(TimeSVG)
